import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { RouteContentType } from 'layers/content/v2/Hocs/FlaggedRouteContentGetter'
import NavigationHelper from 'layers/navigation/navigationHelper'
import { hasBreadcrumbLinks } from 'utils/breadcrumbHelpers'
import CardSection from './cardSection'
import {
  PageContentWrapper,
  HeaderText,
  BreadcrumbRow,
  HeaderContainer,
  HeaderDescription,
  ContentContainer,
  ContentHeader,
  ContentSubHeader,
  StyledBodyCopy,
  CardContentContainer,
} from './component.styles'

export const ExtensionActivities = ({ routeContent, navigationEvent }) => {
  const content = routeContent?.content
  const extensionLanding = content?.extensionLanding
  const breadcrumb = extensionLanding?.breadcrumb
  const displayTitle = extensionLanding?.displayTitle
  const description = extensionLanding?.description
  const contentArray = extensionLanding?.content

  // Filter out content items that have cards
  const cardData =
    contentArray?.filter(
      item => Array.isArray(item?.cards) && item.cards.length > 0,
    ) || []

  const headerBodyCopyData =
    contentArray?.filter(item => item?.contentType === 'HeaderBodyCopy') || []

  const handleClick = path => {
    navigationEvent?.(path, NavigationHelper.types.PUSH)
  }

  return (
    <PageContentWrapper>
      <HeaderContainer hasBreadcrumb={hasBreadcrumbLinks(breadcrumb)}>
        <BreadcrumbRow breadcrumb={breadcrumb} />
        <HeaderText>{displayTitle}</HeaderText>
        <HeaderDescription>{description}</HeaderDescription>
      </HeaderContainer>

      <ContentContainer>
        {headerBodyCopyData.map((item, index) => (
          <Fragment key={item?.id || index}>
            {item?.h2 && <ContentHeader>{item.h2}</ContentHeader>}
            {item?.h3 && <ContentSubHeader>{item.h3}</ContentSubHeader>}
            {item?.bodyCopy && <StyledBodyCopy>{item.bodyCopy}</StyledBodyCopy>}
          </Fragment>
        ))}

        <CardContentContainer>
          {cardData?.map((section, index) => (
            <CardSection
              handleClick={handleClick}
              key={index}
              section={section}
            />
          ))}
        </CardContentContainer>
      </ContentContainer>
    </PageContentWrapper>
  )
}

ExtensionActivities.propTypes = {
  navigationEvent: PropTypes.func.isRequired,
  routeContent: RouteContentType(
    PropTypes.shape({
      redirectRule: PropTypes.shape({
        routeData: PropTypes.shape({
          route: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
    }),
  ),
}
